/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_EyebrowInputs */

const en_directory_tools_eyebrow = /** @type {(inputs: Directory_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available now`)
};

const zh_directory_tools_eyebrow = /** @type {(inputs: Directory_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前可用`)
};

/**
* | output |
* | --- |
* | "Available now" |
*
* @param {Directory_Tools_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_eyebrow = /** @type {((inputs?: Directory_Tools_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_eyebrow(inputs)
	return zh_directory_tools_eyebrow(inputs)
});
export { directory_tools_eyebrow as "directory.tools.eyebrow" }